import React, { useEffect, useState } from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Tabs = ({ values = [], fullWidth, defaultTab, selectedTab, tabRowActive = true, contentStyling, dataCy, onTabSelected, children, }) => {
    const [activeTab, setActiveTab] = useState(defaultTab !== null && defaultTab !== void 0 ? defaultTab : 0);
    useEffect(() => {
        var _a;
        if (selectedTab &&
            selectedTab >= 0 &&
            selectedTab < values.length &&
            !((_a = values[selectedTab]) === null || _a === void 0 ? void 0 : _a.disabled)) {
            setActiveTab(selectedTab);
        }
    }, [selectedTab]);
    const handleTabSelected = (tab, index) => {
        if (!tab.disabled && index !== activeTab) {
            setActiveTab(index);
            onTabSelected === null || onTabSelected === void 0 ? void 0 : onTabSelected(index);
        }
    };
    return (React.createElement("div", { id: "tabs", "data-cy": dataCy },
        React.createElement("section", null, tabRowActive && (React.createElement("ul", { className: classNames(midas.tab, fullWidth && midas.tabBlock) }, values.map((tab, index) => (React.createElement("li", { key: tab.key, className: classNames(midas.tabItem, index === activeTab && midas.active) },
            React.createElement("a", { title: tab.title, style: tab.disabled
                    ? { color: 'lightgrey', cursor: 'default' }
                    : undefined, role: "navigation", onClick: () => handleTabSelected(tab, index) }, tab.value))))))),
        React.createElement("section", null, values.map((tab, index) => !tab.disabled &&
            index === activeTab && (React.createElement("article", { key: tab.key, style: contentStyling }, tab.content)))),
        children));
};
export default Tabs;
